module.exports = __webpack_public_path__ + "static/img/302.3f471c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190926/302.jpg
// module id = vlT9
// module chunks = 0